import { render, staticRenderFns } from "./mainMerchant.vue?vue&type=template&id=ac1e6a6c&scoped=true"
import script from "./mainMerchant.vue?vue&type=script&lang=js"
export * from "./mainMerchant.vue?vue&type=script&lang=js"
import style0 from "./mainMerchant.vue?vue&type=style&index=0&id=ac1e6a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1e6a6c",
  null
  
)

export default component.exports